import React from 'react';

/**
 * NotificationBadge — Facebook-style red badge with white number.
 * Renders nothing when count <= 0. Designed to be positioned absolutely
 * inside a relatively-positioned parent (e.g. a tile or button).
 *
 * Usage:
 *   <div className="relative">
 *     <SomeTile />
 *     <NotificationBadge count={3} position="top-right" />
 *   </div>
 */
export default function NotificationBadge({ count = 0, position = 'top-right', size = 'md' }) {
  if (!count || count <= 0) return null;
  const display = count > 99 ? '99+' : String(count);

  const positions = {
    'top-right':  'top-2 right-2',
    'top-left':   'top-2 left-2',
    'inline':     '',
  };

  const sizes = {
    sm: 'h-5 min-w-[20px] text-[10px] px-1.5',
    md: 'h-6 min-w-[24px] text-xs px-2',
    lg: 'h-7 min-w-[28px] text-sm px-2',
  };

  const base = `inline-flex items-center justify-center rounded-full bg-red-600 text-white font-bold ring-2 ring-white shadow-lg ${sizes[size] || sizes.md}`;

  if (position === 'inline') {
    return <span className={base} data-testid="notification-badge">{display}</span>;
  }

  return (
    <span
      className={`absolute ${positions[position] || positions['top-right']} ${base} z-10`}
      data-testid="notification-badge"
      aria-label={`${count} unread notifications`}
    >
      {display}
    </span>
  );
}
